/** Keys an answer by question id, and by question id + layer for the jurisdiction question. */
export function answerKey(questionId: string, layer?: string | null): string {
  return layer ? `${questionId}|${layer}` : questionId;
}
